
export const activities = {
  title: "What We Do",
  subtitle: "Our Montessori inspiration in action",
  items: {
    personal: {
      title: "Personal Work",
      description: "Children manage their challenges based on their interests and record them daily."
    },
    workshops: {
      title: "Workshops and Projects",
      description: "Group work activities or research proposed according to interests and needs."
    },
    tutoring: {
      title: "Tutoring",
      description: "Close and personalized support for each child in their development process."
    },
    assembly: {
      title: "Assemblies",
      description: "Weekly meetings to resolve doubts, share ideas, and agree on aspects of coexistence."
    },
    rest: {
      title: "Rest Time",
      description: "Children manage their work and rest time according to their needs."
    },
    play: {
      title: "Play",
      description: "Fundamental tool for learning, expansion, social openness, and enjoyment."
    }
  }
};
